import { DateFormat, ds } from "@/plugins/i18n-formatted"
import { Options } from "@model/Setting"
import SettingsRepo from "@repo/SettingsRepo"
import { useRepo } from "pinia-orm"
import { version } from '@/../package.json'

export function exportEvent ( event ) {
    const settingsRepo = useRepo( SettingsRepo )

    return {
        software: 'Score System',
        version: version,
        contentPurpose: 'event saved as a file',
        lang: settingsRepo.getOption( Options.Language ),
        dbStructureVersion: settingsRepo.getOption( Options.DbStructureVersion ),
        sailingDataTimestamp: ds( settingsRepo.getOption( Options.LastSailingDataUpdated ), DateFormat.System ),
        authorizedScorer: settingsRepo.getOption( Options.AuthFullName ),
        generated: ds( new Date, DateFormat.System ),
        event: event.dump
    }
}